module.exports = __webpack_public_path__ + "static/media/ww_rad1.1a8609ce.gif";